<template>
	<picture>
		<source :data-srcset="srcsetWebp" type="image/webp" />
		<img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" :data-src="fullSrcUrl" class="lazyload" />
	</picture>
</template>

<script>
export default {
	name: 'LazyImage',
	props: {
		isBackground: {
			type: Boolean,
			default: true,
		},
		src: {
			type: String,
			required: true,
		},
		srcWidth: {
			type: Number,
			default: 10000,
		},
		responsiveWidths: {
			type: Array,
			default: () => [],
		},
	},
	computed: {
		fullSrcUrl() {
			if (!this.src) return '';
			return this.cdnHost + this.src;
		},
		srcsetWebp() {
			if (!this.src) return '';
			const pos = this.fullSrcUrl.lastIndexOf('.'),
				fileName = this.fullSrcUrl.substr(0, pos),
				defaultSrcset = `${fileName}.webp` + (this.srcWidth ? ` ${this.srcWidth}w` : '');

			return this.responsiveWidths.reduce((accumulator, width) => {
				return accumulator + `, ${fileName}_${width}w.webp ${width}w`;
			}, defaultSrcset);
		},
	},
};
</script>

<style scoped>
img {
	height: 100%;
	left: 0;
	margin: auto;
	object-fit: contain;
	position: absolute;
	right: 0;
}
</style>
